import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcUndo24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m6.79 11.387a1 1 0 0 1 -1.403 1.403l-3.177-3.177a1 1 0 0 1 0-1.226l3.177-3.177c.36-.28.995-.25 1.323.083.328.334.36.96.08 1.32l-1.375 1.387h11.085a5.5 5.5 0 0 1 .221 10.996l-8.721.004a1 1 0 0 1 -.117-1.993l8.617-.007a3.5 3.5 0 0 0 .192-6.995l-11.277-.005z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcUndo24;
